export const TEST_IDS = {
  PARTNER_DETAILS: 'partner-details',
  CLOUD_SECURITY_PARTICIPANT_TOOLTIP: 'cloud-security-participant__tooltip',
  CLOUD_SECURITY_PARTICIPANT_TOOLTIP_V2: 'cloud-security-participant__tooltip_v2',
  CLOUD_FORTIFIED_TOOLTIP: 'cloud-fortified__tooltip',
  CLOUD_FORTIFIED_TOOLTIP_V2: 'cloud-fortified__tooltip_v2',
  CLOUD_FORTIFIED_INFO_MODAL: 'cloudfortified-info-modal',
  CERTIFICATION_SECTION: 'certification-section',
  APP_HEADER_LOZENGES: 'app-header__lozenges',
  APP_HEADER: 'app-header',
  APP_HEADER_ICON: 'app-header__icon',
  APP_HEADER_APP_NAME: 'app-header__app-name',
  APP_HEADER_COMPATIBILITIES: 'app-header__compatibilities',
  APP_HEADER_RATINGS: 'app-header__ratings',
  APP_HEADER_INSTALL_COUNT: 'app-header__install-count',
  APP_HEADER_CERTIFICATION: 'app-header__certification',
  APP_HEADER_STAFF_PICK: 'app-header__staff-pick',
  APP_HEADER_INJECTION: 'app-header__injection'
};